export default "__VITE_ASSET__B1tj_evW__"